import type { TJobStatus } from "../JobStatus";
import type { TRiskRankWithNA } from "../risk/Risk";


export class ReportBrief {
    reportTitle: string = "";
    reportLink: string | null = null;
    reportLabel: string = ""; 
    reportId: string = "";
    reportType: string = "";

    statusMessage: string = "";
    status: TJobStatus = "none";

    contentVersion: number = 0;
    overallRiskRank: TRiskRankWithNA = "n/a";
    isStale: boolean = false;
    useCaseChatId: string = "";
    riskProfileId: string = "";

    constructor(init?: Partial<ReportBrief>) {
        Object.assign(this, init);
    }
}

